import React, { useState, useEffect } from "react";
import { fetchFiles } from "../Utility/Storage/storageUtils";
import { retrieveMineData } from "../Utility/ConsumeToken/consumeToken";
import { getFileDeep, deleteFiles, renameFiles } from "../Utility/ManageFiles/fileUtils";
import Header from "../components/header";
import Output from "../components/outputStorage";
import { useNavigate } from 'react-router-dom';
import { useGID } from '../context/GIDContext';
import { sortFilesByDate } from '../Utility/Storage/storageUtils';


function DeepsageStorage() {
    const [files, setFiles] = useState([]);
    const [nameFilter, setNameFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { setGid } = useGID();

    useEffect(() => {
        async function loadFiles() {
            try {
                const apitoken = await retrieveMineData();
                const fileList = await fetchFiles(apitoken._id, "DEEPSAGE_REPORTS");
                console.log("File ricevuti:", fileList);
                setFiles(fileList);
            } catch (error) {
                console.error("Errore nel caricamento dei file:", error);
            } finally {
                setIsLoading(false);
            }
        }
        loadFiles();
    }, []);

    const handleNameFilterChange = (event) => {
        setNameFilter(event.target.value);
    };

    const handleDateFilterChange = (event) => {
        setDateFilter(event.target.value);
    };

    const filteredFiles = files.filter((file) => {
        const matchesName = file.filename.toLowerCase().includes(nameFilter.toLowerCase());
        const matchesDate = dateFilter ? file.date === dateFilter : true;
        return matchesName && matchesDate;
    });

    // Funzione per visualizzare il report
    const viewReport = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            const fileData = await getFileDeep("DEEPSAGE_REPORTS", fileName, apitoken);
            const GID = fileName.replace(".md", "");
            setGid(GID);
            const reportContent = typeof fileData === "string" ? fileData : fileData.output;
            navigate('/deepsage', { state: { params: { reportContent } } });
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const deleteReport = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            const GID = fileName.replace(".md", "");
            await deleteFiles(apitoken._id, "DEEPSAGE_REPORTS", GID);
            alert("File deleted successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const renameReport = async (fileName, newName) => {
        try {
            const apitoken = await retrieveMineData();
            const GID = fileName.replace(".md", "");
            await renameFiles(apitoken._id, "DEEPSAGE_REPORTS", GID, newName);
            alert("File renamed successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const sortedFiles = sortFilesByDate(filteredFiles, 'desc');

    return (
        <>
            <Header />
            <div className="riga headerStorage">
                <h3 className="titolo titoloManage noMarginBottom">DEEPSAGE STORAGE</h3>
                <span className="description text">
                    Here, you can access and review all output files generated by our DeepSage tool. These files are organized and cataloged for your convenience, making it easy to locate and reuse data across various tools within the platform.
                </span>
                <div className="space"></div>

                <div className="div50">
                    <label>Search by Name:</label>
                    <input
                        type="text"
                        placeholder="Search for a specific report by typing it here...."
                        value={nameFilter}
                        onChange={handleNameFilterChange}
                    />
                </div>

                <div className="div50">
                    <label>Filter by Date:</label>
                    <input
                        type="date"
                        value={dateFilter}
                        onChange={handleDateFilterChange}
                    />
                </div>

                <div className="space"></div>
                <hr />
            </div>
            <div className="riga space-bottom bodyStorage">
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <div>
                        {sortedFiles.length === 0 ? (
                            <p>Files not found</p>
                        ) : (
                            sortedFiles.map((file, index) => (
                                <Output
                                    key={index}
                                    name={file.filename}
                                    date={file.date}
                                    action={() => viewReport(file.filename)}
                                    textAction="View Report"
                                    deleteFile={() => deleteReport(file.filename)}
                                    renameFile={(newName) => renameReport(file.filename, newName)}
                                />
                            ))
                        )}
                    </div>
                )}
            </div>
        </>
    );
}

export default DeepsageStorage;
